module.exports = require("net");


//////////////////
// WEBPACK FOOTER
// external "net"
// module id = 36
// module chunks = 0